/* unplugin-vue-components disabled */import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = ["disabled"];
const _hoisted_2 = {
  key: 0,
  class: "spinner-border text-dark",
  role: "status"
};
export default {
  __name: 'facebookLogin',
  setup(__props) {
    const {
      useActions
    } = createNamespacedHelpers("user");
    const {
      socialLogin,
      setProvider
    } = useActions(["socialLogin", "setProvider"]);
    let facebookLoader = ref(null);
    let loginWithFacebook = async () => {
      window.FB.login(response => {
        if (response.authResponse) {
          facebookLoader.value = true;
          setProvider({
            provider: "facebook",
            access_token: response.authResponse.accessToken
          });
          socialLogin({
            provider: "facebook",
            access_token: response.authResponse.accessToken
          });
          FB.api("/me", function (response) {});
          facebookLoader.value = false;
        } else {
          console.log(" login User cancelled login or did not fully authorize.");
        }
      }, {
        scope: "public_profile,email"
      });
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("button", {
        onClick: _cache[0] || (_cache[0] = (...args) => _unref(loginWithFacebook) && _unref(loginWithFacebook)(...args)),
        class: "btn social-bg",
        disabled: _unref(facebookLoader)
      }, [_unref(facebookLoader) ? (_openBlock(), _createElementBlock("div", _hoisted_2)) : _createCommentVNode("", true), _cache[1] || (_cache[1] = _createElementVNode("svg", {
        class: "fb",
        width: "20",
        height: "36",
        viewBox: "0 0 20 36",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, [_createElementVNode("path", {
        d: "M18.018 20.25L19.018 13.735H12.766V9.507C12.766 7.725 13.639 5.987 16.439 5.987H19.281V0.44C17.6126 0.170553 15.9268 0.023494 14.237 0C9.091 0 5.723 3.12 5.723 8.769V13.734H0V20.25H5.723V36H12.766V20.25H18.018Z",
        fill: "#3C5A9A"
      })], -1))], 8, _hoisted_1);
    };
  }
};